/* jshint undef: true, unused: true */

function stringifyExplicitObject(subject) {
  return '{' + Object
    .entries(subject)
    .map(function (entry) {
      return entry[0] + ':' + stringify(entry[1]);
    })
    .join(',') + '}';
}
function stringifyArray(subject) {
  return '[' + subject.map(function (element) {
    return stringify(element);
  }).join(',') + ']';
}
function stringifyObject(subject) {
  // Check if the subject is an array. If so...
  return subject.constructor === [].constructor
    // Treat it as an array. Otherwise...
    ? stringifyArray(subject)
    // Treat it as an explicit object.
    : stringifyExplicitObject(subject);
}
function stringify (subject) {
  // Check if the subject is an object. If so...
  return typeof subject === 'object'
    // Treat it as an object. Otherwise...
    ? stringifyObject(subject)
    // Treat it as a primitive value.
    : JSON.stringify(subject);
}

module.exports = stringify;
